import { BaseObjectEntity } from '@/types';
import { path } from '@/utils/formatLink';

export const ROOT_SCHEDULED_JOBS = '/scheduled-jobs';

export const PATH_SCHEDULED_JOBS: BaseObjectEntity = {
  root: ROOT_SCHEDULED_JOBS,
  list: '',
};

export function scheduledJobsPath(pathKey: string) {
  return path(ROOT_SCHEDULED_JOBS, PATH_SCHEDULED_JOBS[pathKey]);
}
